import { Common } from './common';
import {
  FindAllOptions,
  InsuranceInformation,
  PredictedPlanResult,
} from './models/patient/insuranceInformation';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    patientId: string,
    query?: FindAllOptions,
  ): Promise<InsuranceInformation[]> {
    const url = this.common.constructPath(
      `/patients/${patientId}/insurance-information`,
      query,
    );
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<InsuranceInformation> {
    const url = this.common.constructPath(
      `/patient-insurance-information/${id}`,
    );
    return await this.common.getJSON(url);
  }

  async update(
    id: string,
    values: Partial<InsuranceInformation>,
  ): Promise<InsuranceInformation> {
    const url = this.common.constructPath(
      `/patient-insurance-information/${id}`,
    );
    return this.common.patchJSON(url, values);
  }

  async debugPlanSelection(
    patientInsuranceInformationId: string,
  ): Promise<PredictedPlanResult | undefined> {
    const url = this.common.constructPath(
      `/patient-insurance-information/${patientInsuranceInformationId}/plan`,
    );
    return await this.common.getJSON(url);
  }
}
